export default "__VITE_ASSET__Cs8iy5mB__"